import { defineStore } from 'pinia';

// eslint-disable-next-line import/prefer-default-export
export const usePageHeaderStore = defineStore('page-header', {
    state: () => ({
        title: '',
        sub_title: '',
        title_id: '',
        buttons: [],
        breadcrumbs: [],
    }),
    actions: {
        update(update) {
            this.title = update.title || '';
            this.sub_title = update.sub_title || '';
            this.title_id = update.title_id || '';
            this.buttons = update.buttons || [];
            this.breadcrumbs = update.breadcrumbs || [];
        },
    },
});
